var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weui-uploader"},[_c('div',{staticClass:"weui-uploader__bd"},[_c('div',{staticClass:"weui-uploader__input-box",class:{ 'weui-uploader__input-box__bgimage': _vm.value },style:(_vm.fileBoxStyle)},[_c('input',{staticClass:"weui-uploader__input",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onSelectFile}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }